<div class="input-group align-items-center" #resizeSensor>
  @if (label) {
    <label class="form-label" class="me-2" for="dateRangePicker">{{ label }}</label>
  }

  <input
    class="form-control form-control--readonly date-range-picker__input"
    id="dateRangePicker"
    [disabled]="disabled"
    [ngClass]="ngClass"
    [value]="inputValue"
    (focus)="popover.show()"
    autocomplete="off"
    readonly
  />

  <button
    class="btn btn-light rounded-end date-range-picker__toggle"
    #popover="tippy"
    [disabled]="disabled"
    [duration]="100"
    [interactive]="true"
    [popover]="true"
    [portalTippy]="popoverContent"
    (click)="open()"
    (hidden)="setOpenState(false)"
    (shown)="calculateStartDate()"
    placement="bottom-end"
    popoverClass="date-range-picker"
    trigger="manual"
    type="button"
  >
    <i class="far fa-calendar"></i>
  </button>
</div>

<ng-template #popoverContent>
  <div class="date-range-picker__container">
    <ngb-datepicker
      [dayTemplate]="t"
      [displayMonths]="visibleMonths"
      [maxDate]="ngbMaxDate"
      [minDate]="ngbMinDate"
      [startDate]="startDate"
      (dateSelect)="onDateSelection($event)"
      outsideDays="hidden"
    ></ngb-datepicker>

    @if (showPredefinedRanges === true && anyRangeAvailable === true) {
      <div class="date-range-picker__quick-ranges">
        <div class="quick-ranges__heading">{{ 'common.range.predefined' | translate }}</div>
        <ul>
          <!-- Today -->
          @if (availableRanges[QuickRange.Today] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.Today }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.Today)">
                {{ 'common.range.Today' | translate }}
              </button>
            </li>
          }
          <!-- Yesterday -->
          @if (availableRanges[QuickRange.Yesterday] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.Yesterday }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.Yesterday)">
                {{ 'common.range.Yesterday' | translate }}
              </button>
            </li>
          }
          <!-- Current Week -->
          @if (availableRanges[QuickRange.CurrentWeek] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.CurrentWeek }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.CurrentWeek)">
                {{ 'common.range.CurrentWeek' | translate }}
              </button>
            </li>
          }
          <!-- Previous Week -->
          @if (availableRanges[QuickRange.PreviousWeek] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.PreviousWeek }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.PreviousWeek)">
                {{ 'common.range.PreviousWeek' | translate }}
              </button>
            </li>
          }
          <!-- Current Month -->
          @if (availableRanges[QuickRange.CurrentMonth] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.CurrentMonth }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.CurrentMonth)">
                {{ 'common.range.CurrentMonth' | translate }}
              </button>
            </li>
          }
          <!-- Previous Month -->
          @if (availableRanges[QuickRange.PreviousMonth] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.PreviousMonth }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.PreviousMonth)">
                {{ 'common.range.PreviousMonth' | translate }}
              </button>
            </li>
          }
          <!-- Current Quarter -->
          @if (availableRanges[QuickRange.CurrentQuarter] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.CurrentQuarter }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.CurrentQuarter)">
                {{ 'common.range.CurrentQuarter' | translate }}
              </button>
            </li>
          }
          <!-- Previous Quarter -->
          @if (availableRanges[QuickRange.PreviousQuarter] === true) {
            <li [ngClass]="{ selected: selectedRange === QuickRange.PreviousQuarter }">
              <button class="btn btn--portal-link" (click)="selectRange(QuickRange.PreviousQuarter)">
                {{ 'common.range.PreviousQuarter' | translate }}
              </button>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</ng-template>

<ng-template #t let-date="date" let-disabled="disabled" let-focused="focused">
  <span
    class="custom-day"
    [class.disabled]="disabled"
    [class.faded]="isHovered(date) || isInside(date)"
    [class.focused]="focused"
    [class.range]="isRange(date)"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null"
  >
    {{ date.day }}
  </span>
</ng-template>
